<template>
  <section class="small-basket-control">
    <div class="small-basket-control__icon" @click="handlerOpenBasket">
      <svg><use xlink:href="#svg-basket"></use></svg>
      <span v-if="count > 0" class="small-basket-control__count">{{ count }}</span>
    </div>
    <DefEmpty v-if="isOpenMessage && !(count > 0)" @close="isOpenMessage = false">
      {{ messages.noItems }}
    </DefEmpty>
  </section>
</template>

<script lang="ts" setup>
import DefEmpty from '@components/Def/DefEmpty/DefEmpty.vue';
import useBasketModal from '@use/useBasketModal';
import { ref, computed } from 'vue';
import { useBasketStore } from '@/storePinia/stores/basket';

const basketModal = useBasketModal();
const basketStore = useBasketStore();

const isOpenMessage = ref(false);

const messages = computed(() => basketStore.messages);
// const items = computed(() => basketStore.items);
const count = computed(() => basketStore.count);

const handlerOpenBasket = () => {
  if (count.value > 0) {
    basketModal.open();
  } else {
    isOpenMessage.value = true;
  }
};
</script>

<style lang="scss" scoped>
.small-basket-control {
  &__icon {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    svg {
      display: block;
      width: 24px;
      height: 24px;
      fill: var(--background-black);
      transition: 0.2s linear fill, 0.2s linear transform;
    }
    &:hover {
      svg {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
      .small-basket-control__count {
        //color: var(--color-link-hover-dark);
      }
    }
  }
  &__count {
    font-weight: 600;
    font-size: rem(12);

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 16px;
    height: 16px;
    background-color: var(--color-main);
    border-radius: 50%;
    position: absolute;
    top: -8px;
    right: -8px;
    color: #fff;
  }
}
</style>
